var map = {
	"./decidim/avatar-multiuser.png": 16770,
	"./decidim/brands/facebook.svg": 27764,
	"./decidim/brands/google.svg": 1325,
	"./decidim/brands/twitter-x.svg": 36446,
	"./decidim/cc-badge.png": 91644,
	"./decidim/decidim-logo.svg": 24112,
	"./decidim/default-avatar.svg": 99784,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 63188,
	"./decidim/icons.svg": 84547,
	"./decidim/pattern.png": 45940,
	"./decidim/placeholder-card-g.svg": 38241,
	"./decidim/placeholder-card-l.svg": 22154,
	"./decidim/placeholder.jpg": 8345,
	"./decidim/remixicon.symbol.svg": 59597,
	"./decidim/vendor/social-share-button/douban.svg": 85756,
	"./decidim/vendor/social-share-button/email.svg": 30489,
	"./decidim/vendor/social-share-button/facebook.svg": 2735,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 8561,
	"./decidim/vendor/social-share-button/hacker_news.svg": 91961,
	"./decidim/vendor/social-share-button/linkedin.svg": 3161,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 22554,
	"./decidim/vendor/social-share-button/pinterest.svg": 73343,
	"./decidim/vendor/social-share-button/reddit.svg": 67875,
	"./decidim/vendor/social-share-button/telegram.svg": 38806,
	"./decidim/vendor/social-share-button/tumblr.svg": 77813,
	"./decidim/vendor/social-share-button/twitter.svg": 86984,
	"./decidim/vendor/social-share-button/vkontakte.svg": 78854,
	"./decidim/vendor/social-share-button/wechat.svg": 32161,
	"./decidim/vendor/social-share-button/whatsapp.svg": 24713,
	"./decidim/vendor/social-share-button/x.svg": 35777,
	"./decidim/vendor/social-share-button/xing.svg": 56879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4339;